import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SquadContainer from './squad-container';
import PlayerContainer from './player-container';

function Squad() {
  return (
    <Switch>
      <Route exact path="/squad/:teamId" component={SquadContainer} />
      <Route exact path="/squad/:teamId/player" component={PlayerContainer} />
    </Switch>
  );
}

export default Squad;
